module.exports = __webpack_public_path__ + "static/media/kirkway-estates-master-deed.c4617ed4.pdf";